<div class="my-container">
    <ng-template #customLoadingTemplate>
        <div class="custom-class">
            <!-- <h3>Loading...</h3> -->
        </div>
    </ng-template>

    <ngx-loading [config]="config" [show]="loading"
        [template]="customLoadingTemplate"></ngx-loading>
</div>